module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/cohort-v-mentors.json
// module id = 674
// module chunks = 39308809987186